<!-- Zweck: Stellt die HTML-Struktur für app layouts login component im Frontend bereit. -->
<app-loader></app-loader>
<div class="logincontent">
  <ngx-simplebar style="height: 100%">
    <router-outlet></router-outlet>
  </ngx-simplebar>
</div>
